import enhance from './OverviewMap.enhancer'
import OverviewMap from './OverviewMap'

export default enhance(OverviewMap)



// WEBPACK FOOTER //
// ./src/components/organisms/OverviewMap/index.js